import {AxiosInstance} from 'axios';
import httpService from '@core/services/AxiosApiService';
import Configuration from '@core/services/ConfigProvider';

/**
 * Pass-through to shared Axios instances from {@link HttpService} (`api` = `/api/`, `defaultAPI` = host root).
 * Prefer `getApiInstance` for API routes; use `getDefaultApiInstance` only for non-`/api/` paths.
 * `getBaseUrl()` returns the configured backend host without path.
 */
class ApiService {
  private readonly baseUrl: string;
  private readonly api: AxiosInstance;
  private readonly defaultAPI: AxiosInstance;
  private readonly strapiBffApi: AxiosInstance;

  constructor() {
    this.baseUrl = Configuration.value('backendHost');
    this.api = httpService.api;
    this.defaultAPI = httpService.defaultAPI;
    this.strapiBffApi = httpService.strapiBffApi;
  }

  getBaseUrl(): string {
    return this.baseUrl;
  }

  getApiInstance(): AxiosInstance {
    return this.api;
  }

  getDefaultApiInstance(): AxiosInstance {
    return this.defaultAPI;
  }

  getStrapiBffApiInstance(): AxiosInstance {
    return this.strapiBffApi;
  }
}

export default new ApiService();
